import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

const Toolbar: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')({
  width: '100%',
  height: '32px',
  display: 'flex',
  gap: '10px',
});

export default Toolbar;